import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PopupModal from './PopupModal';

export default function BookSection({ title, description, imgSrc, linkText, linkTo }) {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);
  const navigate = useNavigate();

  return (
    <div id='homapage_book' className="sectionContainer">
      <div className="container pb-5">
        <div className="row justify-content-center">
          <div className="col-md-5">
            <img
              src={imgSrc}
              alt={title}
              className="book img-fluid"
            />
          </div>
          <div className="col-md-5">
            <h3>{title}</h3>
            <p>{description}</p>

            {/* Open popup instead of navigating */}
            <button
              type="button"
              className="c_button text-decoration-none fw-bold"
              onClick={() => setIsOpen(true)}
            >
              {linkText || 'Más información'}
            </button>
          </div>
        </div>
      </div>

      {/* Use the shared PopupModal component */}
      <PopupModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        /* description={
          'Por el momento, el libro está disponible para compra únicamente en Estados Unidos a través de Amazon. Si te encuentras en México u otro país y deseas adquirir una copia, por favor contáctanos directamente y con gusto te ayudaremos a gestionar tu pedido.'
        } */
        description={
          'Si deseas adquirir una copia, por favor contáctanos directamente y con gusto te ayudaremos a gestionar tu pedido.'
        }
        primary={{ label: 'Contacto por WhatsApp', href: linkTo || '/contact' }}
        secondary={{ label: 'Contacto del Sitio', onClick: () => navigate('/contact') }}
      />
    </div>
  );
}